export { CustomerDetails } from "./model";
export { customer as reducer } from "./reducer";
export { getCustomer } from "./actions";
export { GET_CUSTOMER } from "./actionTypes";
